import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { partnerNameFromUrl } from "../../utils/constants";

export default function Nav() {
  const navigate = useNavigate();
  useEffect(() => {
    // navigate(`/frontend/partnerName`);
    navigate(partnerNameFromUrl);
  }, []);
}
